module.exports = __webpack_public_path__ + "img/inspect_item_bg.60cf2b73.png";